import { IonButton, IonButtons, IonCol, IonFooter, IonGrid, IonRow, IonToolbar } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setAcknowledgePrivacyNotice } from '../store/signatures.actions'
import { useHistory } from 'react-router-dom'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import DOMPurify from 'dompurify'
import { getCustomSignaturesSelector } from '../../customSignature/selectors/getCustomSignature.selectors'
import {
  setCustomAcknowledgePrivacyNotice,
  setacknowledgedPrivacyNotices,
} from '../../customSignature/store/customSignature.actions'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { ISignatureOptionsState } from '../../options/store/options.types'

const TermsAndConditionsContent = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const signaturesState = useSelector(getSignaturesSelector)
  const customSignaturesState = useSelector(getCustomSignaturesSelector)

  const signatureOptionsState: ISignatureOptionsState = useSelector(getSignatureOptionsSelector)
  const { acknowledgmentText } = signatureOptionsState
  const { updatedTerms, signatureSection, sectionIHeaderText, sectionIIHeaderText, sectionIIIHeaderText } =
    signaturesState
  const { customSignatureClientData } = customSignaturesState
  const { term, currentSelectedOption, acknowledgedPrivacyNotices, signatureType } = customSignatureClientData
  const headerData = signatureType === 'standardSignature' ? updatedTerms : term

  let standardSignatureSectionHeaderData = ''
  const getStandardSignatureSectionHeaderData = () => {
    if (signatureSection) {
      if (signatureSection?.id === 1) standardSignatureSectionHeaderData = sectionIHeaderText
      if (signatureSection?.id === 2) standardSignatureSectionHeaderData = sectionIIHeaderText
      if (signatureSection?.id === 3) standardSignatureSectionHeaderData = sectionIIIHeaderText
    } else {
      standardSignatureSectionHeaderData = ''
    }
  }
  getStandardSignatureSectionHeaderData()

  const buttonDisableCheck =
    signatureType === 'standardSignature'
      ? signaturesState.acknowledgePrivacyNotice
      : customSignatureClientData.acknowledgePrivacyNotice

  const onSaveClick = () => {
    if (signatureType === 'standardSignature') {
      dispatch(setAcknowledgePrivacyNotice(true))
    } else {
      dispatch(setCustomAcknowledgePrivacyNotice(true))
      dispatch(setacknowledgedPrivacyNotices([...acknowledgedPrivacyNotices, currentSelectedOption?.parentID]))
    }
    history.push(AppRouterConstants.SIGNATURE_ROUTE)
  }

  const onBackClick = () => {
    history.push(AppRouterConstants.SIGNATURE_ROUTE)
  }

  return (
    <>
      <IonGrid>
        <IonRow>
          <IonCol>
            <div className='headerSection'>{t('signature.termsAndConditionsHeaderSection')}</div>
          </IonCol>
        </IonRow>
        <IonRow className='mainSectionRow'>
          <IonCol>
            <div className='header'> {t('signature.termsAndConditionsTerms')}</div>
            <div
              className='mainSectionCol'
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(headerData, { ALLOWED_TAGS: ['b'], ALLOWED_ATTR: [''] }),
              }}
            />
          </IonCol>
        </IonRow>
        {signatureType === 'standardSignature' && (
          <IonRow className='mt-1'>
            <IonCol>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(standardSignatureSectionHeaderData, {
                    ALLOWED_TAGS: ['b'],
                    ALLOWED_ATTR: [''],
                  }),
                }}
              />
            </IonCol>
          </IonRow>
        )}
        {signatureType === 'standardSignature' && (
          <IonRow className='mainSectionRow'>
            <IonCol>
              <div className='header'> {t('signature.termsAndConditionsAcknowledgement')}</div>
              <div
                className='mainSectionCol'
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(acknowledgmentText, { ALLOWED_TAGS: ['b'], ALLOWED_ATTR: [''] }),
                }}
              />
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          <IonCol className='mainSectionCol'>
            <IonFooter className='ion-no-border'>
              <IonToolbar color='light' className='toolbar'>
                <IonButtons>
                  <IonButton
                    disabled={buttonDisableCheck}
                    data-testid='MultiSelectCancel'
                    className='btn btn-secondary mr-8'
                    expand='block'
                    id='multiselect-modal-cancel-button'
                    onClick={onBackClick}>
                    {t('common.buttons.Cancel')}
                  </IonButton>
                  <IonButton
                    disabled={buttonDisableCheck}
                    data-testid='MultiSelectSave'
                    className='btn btn-primary'
                    expand='block'
                    id='multiselect-modal-save-button'
                    onClick={onSaveClick}>
                    {t('signature.termsAndConditionsIAgreeButton')}
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonFooter>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  )
}

export default TermsAndConditionsContent
